import { translate } from '../../../utils/GameEngine';
import { IconButton } from './IconButton';

export class AdButton extends IconButton {

    constructor(callback?: () => any, label: string = translate('Watch\nad', true) + '!') {
        super(label, callback, 'pink_btn_large@2x', true, true, 1);
    }

    protected initProperties(): void {
        super.initProperties();
        this.iconTexture = 'ad_icon@2x';
        this.iconScale = 0.4;
    }
}